module.exports = __webpack_public_path__ + "img/acuerdo.70fbe249.jpg";